import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_SUPPLY_CHAINS_FOR_FORM: TypedDocumentNode<Data, Variables> = gql`
  query getSupplyChainsForForm($workspaceId: ID!) {
    supplyChains(workspaceId: $workspaceId) {
      nodes {
        id
        name
      }
    }
  }
`
